const apiURL = 'www.something.com'

export default apiURL